import { DateHelper } from './../../../utils/date-helper';
import { SupportService } from './../../../data/repository/support-repository/support.service';
import { SettingService } from 'src/app/data/repository/setting-repository/setting.service';
import { Component, OnInit } from '@angular/core';
import { messageInboxResponce } from 'src/app/core/model/api-response/support-responce.model';

@Component({
  selector: 'app-message-inbox',
  templateUrl: './message-inbox.component.html',
  styleUrls: ['./message-inbox.component.scss'],
})
export class MessageInboxComponent implements OnInit {
  messages: messageInboxResponce;
  constructor(
    private settingService: SettingService,
    private supportService: SupportService,
    private dateHelper: DateHelper
  ) {}

  ngOnInit() {
    this.supportService.getMessageInbox().then((res) => {
      this.messages = res.getData().getMessageInboxResponce();
      console.log(this.messages);
    });
  }
  getDate(date: Date) {
    return this.dateHelper.getPersianBirthdayFormat(date);
  }
  back() {
    this.settingService.goBack();
  }
  goToMessagePage(id: string) {
    return this.settingService.goToMessagePage(id);
  }
}
